import React from 'react'

import { H, THProps } from 'elements/text/H'

export type TCommunityPageSubTitleProps = THProps

export const CommunityPageSubTitle: TFCC<TCommunityPageSubTitleProps> = ({ children, ...otherProps }) => (
  <H size="2" bold fontSize="1em" m="0 0 20px 0" color="black" font="openSans" {...otherProps}>
    {children}
  </H>
)
